import { createFileRoute } from '@tanstack/react-router';

import { LoginSignupLayout } from '@/auth/layouts/login-signup-layout';

export const Route = createFileRoute('/_login-signup')({
  component: LoginSignupLayout
});
